const BLOG_BASE = /\/blog$/;

const getContentPostPath = (basePath: string, slug: string): string =>
  BLOG_BASE.test(basePath) ? `${basePath}/${slug}` : `${basePath}/post/${slug}`;

export default getContentPostPath;
